import React, { useState, Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ReactSession } from "react-client-session";
import {
  Typography,
  Button,
  Box,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Touriste from "../../images/pictos-ok/JE SUIS.svg";
import Localiste from "../../images/pictos-ok/JE SUIS_1.svg";
import Elupro from "../../images/pictos-ok/elu-pro.svg";
import { useStyles } from "../Theme.js";
//import { useFetchInsertOnservation } from "../ConnexionTools.js";
import CreateUser from "./CreateUser";
import CreateUser2 from "./CreateUser2";
import Connexion from "./Connexion";

const FinalStep = (props) => {
  const location = useLocation();
  const classes = useStyles();
  const history = useHistory();
  const [currentetape, setCurrentetape] = useState("");
  const [value, setValue] = useState("");
  const [usertype, setUsertype] = useState("");
  const loginconnect = ReactSession.get("login");
  const user_id = ReactSession.get("user_id");
  const [connexion, setConnexion] = useState(0);
  const [retour, setRetour] = useState("");
  const [obervationinfo, setobervationinfo] = useState("");
  useEffect(() => {
    console.log(props);
    if (props.currentetape) {
      setCurrentetape(props.currentetape);
    }
    fetchInsertForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event) => {
    // Set la value du state du composant local pour rendu graphique
    setValue(event.target.value);

    // Set la value du state du composant parent
    if (props.result) {
      setUsertype(event.target.value);
    }

    if (event.target.value === "elu-pro") {
      setConnexion(1);
      /*history.push({
        pathname: "/user",
        state: {
          theme: obervationinfo.theme,
          id_observation: obervationinfo.id_observation,
          user_type: usertype,
          etape: currentetape,
          pathname: location.pathname,
        },
      });*/
    } else {
      setConnexion(2);
      /*history.push({
        pathname: "/create-user",
        state: {
          user_type: event.target.value,
          theme: obervationinfo.theme,
          id_observation: obervationinfo.id_observation,
          etape: currentetape,
          pathname: location.pathname,
        },
      });*/
    }

    // Une fois que la réponse est donnée, autorise à avancer dans le form
    //props.setAuthorization(true);
  };
  async function fetchInsertForm() {
    try {
      const requestOptions2 = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(props.result),
      };
      console.log(window.location.protocol);
      const response = await fetch(
        window.location.protocol +
          "//" +
          window.location.hostname +
          `/natturapi/forms/${props.result.section}/${props.result.theme}`,
        requestOptions2
      );
      let obervationinfotmp = await response.json();
      setobervationinfo(obervationinfotmp);
      console.log(obervationinfotmp);
      if (response.status === 201) {
        console.log("Insertion ok :D");
      } else {
        console.log("Ca marche pas :(");
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function fetchInsertOnservation(user_id, theme, id_observation) {
    try {
      console.log(user_id, theme, id_observation);
      const tabuserobservation = {
        id_observation: id_observation,
        theme: theme,
        id_user: user_id,
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tabuserobservation),
      };
      const response = await fetch(
        window.location.protocol +
          "//" +
          window.location.hostname +
          "/natturapi/users/observation",
        requestOptions
      );
      if (response.status === 200) {
        return "Obervation créée";
      } else {
        return "Problème lors de la création";
      }
    } catch (err) {
      console.log(err);
    }
  }
  if (loginconnect) {
    // setRetour(
    console.log(obervationinfo);
    fetchInsertOnservation(
      user_id,
      obervationinfo.theme,
      obervationinfo.id_observation
      //  )
    );
    return (
      <Fragment>
        <Typography variant="h5">
          Merci d'avoir pris le temps de répondre !
        </Typography>
        <Typography variant="body1">
          Ce questionnement a pour vocation d'aider les collectivités à
          améliorer votre expérience. Votre contribution nous aidera à prendre
          les bonnes décisions pour notre territoire.
          <br />
        </Typography>
        <Grid
          container
          style={{
            maxWidth: "100%",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            className={classes.navButton2}
            style={{
              marginTop: 20,
              fontSize: 15,
              BackgroundColor: "#e50039",
              fontWeight: "bold",
            }}
            onClick={() => history.push("/")}
          >
            Retour à l'accueil
          </Button>
        </Grid>
      </Fragment>
    );
  } else {
    if (connexion) {
      if (connexion === 2) {
        return (
          <Fragment>
            {" "}
            <CreateUser
              state={{
                theme: obervationinfo.theme,
                id_observation: obervationinfo.id_observation,
                user_type: usertype,
                etape: currentetape,
                pathname: location.pathname,
              }}
              setConnexion={setConnexion}
            ></CreateUser>{" "}
            <Box style={{ padding: "20px" }}>
              {" "}
              <Button
                variant="contained"
                color="primary"
                className={classes.navButton}
                style={{
                  marginTop: 20,
                  fontSize: 15,
                  BackgroundColor: "#e50039",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  setConnexion(false);
                  setValue(false);
                }}
              >
                &lt; Retour
              </Button>
            </Box>
          </Fragment>
        );
      } else {
        if (connexion === 3) {
          return (
            <Fragment>
              {" "}
              <CreateUser2
                state={{
                  theme: obervationinfo.theme,
                  id_observation: obervationinfo.id_observation,
                  user_type: usertype,
                  etape: currentetape,
                  pathname: location.pathname,
                }}
                setConnexion={setConnexion}
              ></CreateUser2>{" "}
              <Box style={{ padding: "20px" }}>
                {" "}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.navButton}
                  style={{
                    marginTop: 20,
                    fontSize: 15,
                    BackgroundColor: "#e50039",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    setConnexion(false);
                    setValue(false);
                  }}
                >
                  &lt; Retour
                </Button>
              </Box>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              {" "}
              <Connexion
                state={{
                  theme: obervationinfo.theme,
                  id_observation: obervationinfo.id_observation,
                  user_type: usertype,
                  etape: currentetape,
                  pathname: location.pathname,
                }}
              ></Connexion>
              <Box style={{ padding: "20px" }}>
                {" "}
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.navButton}
                  style={{
                    marginTop: 20,
                    fontSize: 15,
                    BackgroundColor: "#e50039",
                    fontWeight: "bold",
                  }}
                  onClick={() => {
                    setConnexion(false);
                    setValue(false);
                  }}
                >
                  &lt; Retour
                </Button>
              </Box>
            </Fragment>
          );
        }
      }
    } else {
      return (
        <Fragment>
          <Box style={{ padding: "20px" }}>
            <Typography variant="h5">
              Merci d'avoir pris le temps de répondre !
            </Typography>
            <Typography variant="body1">
              Ce questionnement a pour vocation d'aider les collectivités à
              améliorer votre expérience. Votre contribution nous aidera à
              prendre les bonnes décisions pour notre territoire.
              <br />
              Dites-nous en plus sur vous ?
            </Typography>

            <Grid
              container
              style={{
                maxWidth: "100%",
                marginTop: "20px",
                paddingLeft: "0",
                paddingRight: "0",
              }}
            >
              <Box
                style={{
                  padding: "0",
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <form
                  action={"./create-user-2"}
                  noValidate
                  autoComplete="off"
                  style={{ width: "100%" }}
                >
                  <RadioGroup
                    aria-label="user_type"
                    name="user_type"
                    value={value}
                    onChange={handleChange}
                    style={{ maxWidth: "100%" }}
                  >
                    <FormControlLabel
                      value="touriste"
                      className={
                        classes.themeButton +
                        " " +
                        (value === "touriste" ? "checked" : "")
                      }
                      control={
                        <Radio
                          className={classes.fullradio}
                          icon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Touriste}
                              alt="touriste"
                            />
                          }
                          checkedIcon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Touriste}
                              alt="touriste"
                            />
                          }
                        />
                      }
                      label={
                        <span>
                          JE SUIS UN TOURISTE
                          <small
                            style={{
                              fontSize: 10,
                              display: "block",
                              lineHeight: "normal",
                            }}
                          >
                            (je ne vis pas dans le département de l’Ariège)
                          </small>
                        </span>
                      }
                      style={{ height: "25vh", textAlign: "center" }}
                    />

                    <FormControlLabel
                      value="local"
                      control={
                        <Radio
                          className={classes.fullradio}
                          icon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Localiste}
                              alt="local"
                            />
                          }
                          checkedIcon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Localiste}
                              alt="local"
                            />
                          }
                        />
                      }
                      className={
                        classes.themeButton +
                        " " +
                        (value === "local" ? "checked" : "")
                      }
                      label={
                        <span>
                          JE SUIS UN <br />
                          HABITANT LOCAL{" "}
                          <small
                            style={{
                              fontSize: 10,
                              display: "block",
                              lineHeight: "normal",
                            }}
                          >
                            (je vis dans le département de l’Ariège)
                          </small>
                        </span>
                      }
                      style={{ height: "25vh", textAlign: "center" }}
                    />

                    <FormControlLabel
                      value="elu-pro"
                      control={
                        <Radio
                          className={classes.fullradio}
                          icon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Elupro}
                              alt="elu-pro"
                            />
                          }
                          checkedIcon={
                            <img
                              style={{
                                maxHeight: 65,
                                maxWidth: "100%",
                                marginBottom: "10px",
                              }}
                              src={Elupro}
                              alt="elu-pro"
                            />
                          }
                        />
                      }
                      className={
                        classes.themeButton +
                        " " +
                        (value === "elu-pro" ? "checked" : "")
                      }
                      label={
                        <span>
                          JE SUIS UN
                          <br />
                          élu ou un pro
                        </span>
                      }
                      style={{ height: "25vh", textAlign: "center" }}
                    />
                  </RadioGroup>
                </form>
              </Box>
            </Grid>
          </Box>
        </Fragment>
      );
    }
  }
};

export default FinalStep;
